/**
 * TEMPORARY — Wix-only DICOM structured report download host.
 * Prod Wix uses WixReportingMicroservice; this endpoint is on dev ReportingMicroservice.
 * Remove this file and its use in `downloadDicomStructuredReportHtml` when prod is aligned.
 */
export const DEV_DICOM_DOWNLOAD_REPORTING_BASE =
  "https://devvetsapimanagement.azure-api.net/ReportingMicroservice";
